import React from 'react';

const EditStaffJob = ({ isShow, editInformation, jobTypeArray, onChangeFunc, saveFunc, toggleFunc}) => {
  const {realName,jobTypeId1=-1,jobTypeId2=-1,jobTypeId3=-1} = editInformation;
  return (
    <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
      <div className="form-block">
        <div className="u-small-title">編輯員工職位</div>
        <form className="u-form">
          <div className="row m-t-16">
            <div className="col-6 col-pad-12">
              <label className="u-form__label text-align-right">姓名：{realName}</label>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">板橋店職位：</label>
              <select value={Number(jobTypeId1)} className="u-form__select" 
                onChange={(e)=>{onChangeFunc('jobTypeId1', e);}}
              >
                <option value="-1">未任職</option>
                {
                  jobTypeArray.map(jobType => (
                    <option key={jobType.id} value={jobType.id}>{ jobType.name }</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className="row">
              
              <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right">北大店職位：</label>
                <select value={Number(jobTypeId3)} className="u-form__select" 
                  onChange={(e)=>{onChangeFunc('jobTypeId3', e);}}
                >
                  <option value="-1">未任職</option>
                  {
                    jobTypeArray.map(jobType => (
                      <option key={jobType.id} value={jobType.id}>{ jobType.name }</option>
                    ))
                  }
                </select>
              </div>
            </div>
          <div className="row">
              
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">海大店職位：</label>
              <select value={Number(jobTypeId2)} className="u-form__select" 
                onChange={(e)=>{onChangeFunc('jobTypeId2', e);}}
              >
                <option value="-1">未任職</option>
                {
                  jobTypeArray.map(jobType => (
                    <option key={jobType.id} value={jobType.id}>{ jobType.name }</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className="u-btn-group right">
            <button className="btn btn-md save" onClick={(e) => {
              e.preventDefault();
              saveFunc();
            }}>儲存</button>
            <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>取消</button>
          </div>
        </form>
      </div>
    </div>
  )

}

export default EditStaffJob;